module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright1"
  }, [_c('strong', [_vm._v("Pistaco")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright0"
  }, [_c('strong', [_vm._v("A Tale of Love in the Andes")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright0"
  }, [_vm._v("By Lynn F. Monahan")]), _vm._v(" "), _c('p', {
    staticClass: "copyright0"
  }, [_vm._v("Edited by Michael Coyne")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Interior layout and typesetting by Don Bashline; cover design by Patricia A. Lynch; author portrait by Mariana Monahan")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Cover photo copyright © Robert Frerck/Robert Harding. Used with permission.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © 2017 by Lynn F. Monahan")]), _vm._v(" "), _c('p', {
    staticClass: "copyright0"
  }, [_vm._v("Published by In Extenso Press")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Distributed exclusively by ACTA Publications, 4848 N. Clark Street, Chicago, IL 60640, (800) 397-2282, "), _c('a', {
    attrs: {
      "href": "http://actapublications.com",
      "target": "_blank"
    }
  }, [_vm._v("actapublications.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced or transmitted in any form or by any means, electronic, digital, or mechanical, including photocopying and recording, or by any information storage and retrieval system, including the Internet, without permission from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Permission is hereby given to use short excerpts with proper citation in reviews and marketing copy, newsletters, bulletins, class handouts, and scholarly papers.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Catalog Number: 2016921219")]), _vm._v(" "), _c('p', {
    staticClass: "copyright0"
  }, [_vm._v("ISBN: 978-0-87946-649-7 (ebook)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f787370","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003_Copyright.vue
// module id = 63
// module chunks = 0